document.addEventListener('DOMContentLoaded', function () {
  const mobileMenu = document.querySelector('.sticky-footer-bloks .menu');

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      e.preventDefault();

      const mobileLeft = document.querySelector('.mobile-toggle');

      if (mobileLeft) {
        mobileLeft.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        );
      }
    });
  }


  // const userLogin = document.querySelector('.sticky-footer-bloks .user_login');
  // if (userLogin) {
  //   userLogin.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     console.log('userLogin clicked ', userLogin)

  //    const shopifyAccount = document.querySelector('.thb-secondary-area .thb-shopify-account');
  //     console.log('shopifyAccount ', shopifyAccount)

  //     const dialog = shopifyAccount?.shadowRoot?.querySelector('.dialog');

  //     if (dialog) {
  //       dialog.setAttribute('open', '');
  //       // dialog.style.setProperty('--dialog-min-height', '313px');
  //     }
      
  //   });
  // }

});
